module.exports = {
          srcSet: __webpack_public_path__ + "public/images/5358595751cf7ecbd41ae7da9a1c1047-1200.jpg"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/5358595751cf7ecbd41ae7da9a1c1047-1200.jpg",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/5358595751cf7ecbd41ae7da9a1c1047-1200.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/5358595751cf7ecbd41ae7da9a1c1047-1200.jpg"},
          
          width: 1200,
          height: 800
        }